export default function storeLogoutRedirect(storage, fromPath) {
  if (fromPath) {
    storage?.setUniversal('redirect', fromPath);
  }
}
